
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 3a1 1 0 011 1v16.053c0 .523-.576.947-1.286.947H4.286C3.576 21 3 20.576 3 20.053V3.947C3 3.424 3.576 3 4.286 3H20zm-3.665 9.668H7.667c-.66 0-.918.855-.37 1.221l3 2a.667.667 0 00.74-1.11l-1.168-.778h6.466a.667.667 0 000-1.333zm-2.632-4.555a.667.667 0 10-.74 1.11l1.168.778H7.666a.667.667 0 000 1.333h8.667c.66 0 .919-.855.37-1.221z"}})])
          )
        }
      }
    